module.exports = __webpack_public_path__ + "media/images/img_house_purchasing_1-0faeae4a041fe83727d6527e378539e7.png";